export const CATEGORY_GET_CATEGORIES = 'category/getCategories'; 
export const CATEGORY_GET_CATEGORY_PRODUCTS_COUNTS = 'category/getCategoryProductsCounts';

export type TYPE_CATEGORY_GET_CATEGORIES = 'category/getCategories'; 
export type TYPE_CATEGORY_GET_CATEGORY_PRODUCTS_COUNTS = 'category/getCategoryProductsCounts';